<video #videoElement class="camera-qr-scan-video-element"></video>
